export default function (id) {
  (function (w, d, t, id, s, f, gt) {
    s = d.createElement(t); s.type = "text/plain"; s.dataset.cookiecategory = "analytics"; s.async = 1; s.crossOrigin = "anonymous"; s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    f = d.getElementsByTagName(t)[0];
    // This is just a trial and error approach to fix rollbar
    // https://app.rollbar.com/a/Aion/fix/item/Aion-production/4077
    if (f) {
      f.parentNode.insertBefore(s, f);
    } else {
      d.head.appendChild(s); // Append to <head> if no <script> tag is found
    }
    w.dataLayer = w.dataLayer || [];
    gt = function () { w.dataLayer.push(arguments); }; gt("js", new Date()); gt("config", id);
  })(window, document, "script", id);
}
